import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import { serializeRtkQueryError } from 'util/rtkQueryError';

export const LOCATION_TAGS = {
  LOCATION: 'TenantLocation'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [LOCATION_TAGS.LOCATION]
});

export const locationApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listTenantLocations: build.query({
      async queryFn(args) {
        const {
          tenantGuid,
          indexStart = 0,
          maxResults = 10,
          search = ''
        } = args || {};

        if (!tenantGuid) {
          return { data: { Objects: [], TotalRecords: 0 } };
        }

        const params = {
          indexstart: indexStart,
          maxresults: maxResults,
          ...(search ? { text: search } : {})
        };

        try {
          const res = await api.TenantLocations.listPaged(tenantGuid, params);
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [{ type: LOCATION_TAGS.LOCATION, id: 'LIST' }]
    }),

    addTenantLocation: build.mutation({
      async queryFn(args) {
        const {
          tenantGuid,
          displayName,
          address_1,
          address_2,
          city,
          state,
          postal,
          description
        } = args || {};

        try {
          const res = await api.TenantLocations.add(
            tenantGuid,
            displayName,
            address_1,
            address_2,
            city,
            state,
            postal,
            description
          );
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      invalidatesTags: [{ type: LOCATION_TAGS.LOCATION, id: 'LIST' }]
    }),

    updateTenantLocation: build.mutation({
      async queryFn(args) {
        const {
          tenantGuid,
          guid,
          displayName,
          address_1,
          address_2,
          city,
          state,
          postal,
          description
        } = args || {};

        try {
          const res = await api.TenantLocations.update(
            tenantGuid,
            guid,
            displayName,
            address_1,
            address_2,
            city,
            state,
            postal,
            undefined,
            description
          );
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      invalidatesTags: [{ type: LOCATION_TAGS.LOCATION, id: 'LIST' }]
    }),

    removeTenantLocation: build.mutation({
      async queryFn({ tenantGuid, guid }) {
        try {
          const res = await api.TenantLocations.remove(tenantGuid, guid);
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      invalidatesTags: [{ type: LOCATION_TAGS.LOCATION, id: 'LIST' }]
    })
  })
});

export const {
  useListTenantLocationsQuery,
  useAddTenantLocationMutation,
  useUpdateTenantLocationMutation,
  useRemoveTenantLocationMutation
} = locationApi;
